import "./styles.scss";

import { Link } from "react-router-dom";
import Dialog from "@material-ui/core/Dialog";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { clearNotify } from "../../store/middleware";
import { setUser } from "../../store/slices/user.slice";
import calendarGooglePNG from "../../assets/images/calendar-google.png";

const arrayList = ["SUBTITLE03_ALERT_NEWS", "SUBTITLE04_ALERT_NEWS", "SUBTITLE05_ALERT_NEWS"];

function ModalAlertnNews({ showModal, setShowModal }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.userReducer);

  const handleClose = async () => {
    const response = await dispatch(clearNotify(user?.id));
    if (!response) return;

    const dataUser = JSON.parse(sessionStorage.getItem("@dataUser"));
    if (!dataUser) return;

    const payload = { ...dataUser, notifyControl: "" };

    dispatch(setUser(payload));
    sessionStorage.setItem("@dataUser", JSON.stringify(payload));
    setShowModal(false);
  };

  return (
    <Dialog
      open={showModal}
      onClose={handleClose}
      className="modalPrivilege"
      classes={"modalAlertnNews"}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <div className="containerAlertnNews">
        <h3 className="title">{t("TITLE_ALERT_NEWS")}</h3>

        <form className="contentAlertnNews">
          <img alt="calendar-google" src={calendarGooglePNG} />

          <p>{t("SUBTITLE01_ALERT_NEWS")}</p>
          <p>{t("SUBTITLE02_ALERT_NEWS")}</p>
          <ul>
            {arrayList.map((item) => (
              <li key={item}>{t(item)}</li>
            ))}
          </ul>
          <p>{t("SUBTITLE06_ALERT_NEWS")}</p>

          <Link to="/manage-account/notification">
            <button className="buttonAccess">{t("GO_TO_NOTIFICATIONS")}</button>
          </Link>
        </form>

        <div className="footer">
          <button className="buttonModalSave" onClick={handleClose}>
            {t("BTN_CLOSE")}
          </button>
        </div>
      </div>
    </Dialog>
  );
}

export default ModalAlertnNews;
